import renderRootElement from '@rover/utilities/renderRootElement';

import ExitBrightHorizonsPartnershipModal from './ExitBrightHorizonsPartnershipModal';

const EXIT_BH_PARTNERSHIP_MODAL = '#react-exit-bh-partnership';

const renderExitBHPartnershipModal = (): void => {
  // eslint-disable-next-line rover/no-platform-specific-globals-or-imports
  if (document.querySelector(EXIT_BH_PARTNERSHIP_MODAL)) {
    renderRootElement(ExitBrightHorizonsPartnershipModal, EXIT_BH_PARTNERSHIP_MODAL);

    if (module.hot) {
      module.hot.accept('./ExitBrightHorizonsPartnershipModal', () => {
        renderRootElement(
          // eslint-disable-next-line @typescript-eslint/no-var-requires
          require('./ExitBrightHorizonsPartnershipModal').default,
          EXIT_BH_PARTNERSHIP_MODAL
        );
      });
    }
  }
};

renderExitBHPartnershipModal();

export const mountExitBHPartnership = (): boolean => {
  if (process.env.JS_ENV_CLIENT) {
    renderExitBHPartnershipModal();
    return true;
  }
  return false;
};

export default ExitBrightHorizonsPartnershipModal;
